import React from 'react'
import moment from 'moment'
import { useTranslation } from '@morningtrain/react-translations'

export default function useTranslatedCurrentMonth () {
  const map = {
    1: 'january',
    2: 'february',
    3: 'march',
    4: 'april',
    5: 'may',
    6: 'june',
    7: 'july',
    8: 'august',
    9: 'september',
    10: 'october',
    11: 'november',
    12: 'december'
  }

  const monthIndex = parseInt(moment().format('M'))
  const enMonth = map[monthIndex]

  return useTranslation(`generic.months.${enMonth}`)
}
